module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "persistent": ""
    },
    model: {
      value: (_vm.$root.confirmAddFile.isVisible),
      callback: function($$v) {
        _vm.$root.confirmAddFile.isVisible = $$v
      },
      expression: "$root.confirmAddFile.isVisible"
    }
  }, [_c('v-card', [_c('v-toolbar', {
    staticClass: "trHeader",
    staticStyle: {
      "height": "40px"
    }
  }, [_c('v-toolbar-title', {
    staticClass: "white--text",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.title))])], 1), _vm._v(" "), _c('v-flex', [_c('v-card-text', [_c('span', {
    staticClass: "custom-dropdown custom-dropdown--white",
    staticStyle: {
      "width": "200px"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addType),
      expression: "addType"
    }],
    staticClass: "custom-dropdown__select custom-dropdown__select--white",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.addType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "File"
    }
  }, [_vm._v("הוסף מסמך חדש")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Folder"
    }
  }, [_vm._v("הוסף תיקייה חדשה")])])])])], 1), _vm._v(" "), (_vm.addType == 'File') ? _c('v-flex', [_c('v-layout', {
    staticStyle: {
      "padding": "20px 10px 10px 10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "right": ""
    }
  }, [_vm._v("\n          שם קובץ\n        ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fileName),
      expression: "fileName"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.fileName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fileName = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "padding": "20px 10px 10px 10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs5": "",
      "right": ""
    }
  }, [_c('label', {
    staticClass: "file-select"
  }, [_vm._v("\n            בחר קובץ\n            "), _c('v-icon', {
    staticClass: "btnIcon mr-2",
    attrs: {
      "right": ""
    }
  }, [_vm._v("attachment")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.upload
    }
  })], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs7": "",
      "right": ""
    }
  }, [(_vm.showProgress) ? _c('span', [_vm._v("מעלה קובץ...")]) : _vm._e(), _vm._v(" "), (_vm.showReady) ? _c('span', [_vm._v(_vm._s(_vm.readyFileName)), _c('v-icon', [_vm._v("check")])], 1) : _vm._e()])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.addType == 'Folder') ? _c('v-flex', [_c('v-layout', {
    staticStyle: {
      "padding": "20px 10px 10px 10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "right": ""
    }
  }, [_vm._v("\n          שם תיקייה\n        ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.folderName),
      expression: "folderName"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.folderName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.folderName = $event.target.value
      }
    }
  })])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "actions": ""
    }
  }, [_c('v-btn', {
    staticClass: "green green--text ml-3",
    attrs: {
      "outline": "",
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.save($event)
      }
    }
  }, [_vm._v("\n        שמירה\n        "), _c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("check")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "red red--text ml-2",
    attrs: {
      "outline": "",
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.cancel($event)
      }
    }
  }, [_vm._v("\n        ביטול\n        "), _c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("block")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3bc42050"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PopupAddFile.vue
// module id = 878
// module chunks = 2